import axios from "axios";
import {jwtDecode} from "jwt-decode";
// @ts-ignore
import Cookies from 'js-cookie';

// default
// axios.defaults.baseURL = process.env.NEXT_PUBLIC_API_GENERAL_URL;
// axios.defaults.baseURL = "http://localhost:8000/api/v1/";
axios.defaults.baseURL = "https://api.yerkir-real.com/api/v1/";

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";


// content type
// const token = localStorage.getItem("token") ? localStorage.getItem("token") : null;
// if (token) {
//     axios.defaults.headers.common["Authorization"] = "Bearer " + token;
// }

// intercepting to capture errors
axios.interceptors.response.use(
    function (response) {
        return response.data ? response.data : response;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        let message;
        console.log("==================------------");
        console.log(error);
        switch (error.response.status) {
            case 500:
                message = error;
                break;
            case 401:
                message = "Invalid credentials";
                break;
            case 404:
                message = "Sorry! the data you are looking for could not be found";
                break;
            default:
                return Promise.reject(error.response.data);
        }
        return Promise.reject(message);
    }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: string) => {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
    /**
     * Fetches data from given url
     */
    get = (url: string, params = {}, headers = {}) => {
        let response;

        if (params) {
            response = axios.get(url, {
                params: params,
                headers: headers
            });
        } else {
            response = axios.get(url, {headers});
        }

        return response;
    };

    /**
     * post given data to url
     */
    create = (url: string, data: any, headers = {}) => {
        return axios.post(url + '/', data, headers);
    };

    /**
     * Updates data
     */
    update = (url: string, data: any) => {
        return axios.patch(url + '/', data);
    };

    put = (url: string, data: any) => {
        return axios.put(url + '/', data);
    };

    /**
     * Delete
     */
    delete = (url: string, config: any = {}) => {
        return axios.delete(url + '/', {...config});
    };
}

const getLoggedInUser = () => {
    const authToken = Cookies.get('access');

    if (authToken) {
        return jwtDecode(authToken);
    }

    return null;
};

export {APIClient, setAuthorization, getLoggedInUser};
